import { MutationTree } from 'vuex';
import { ActionStatus } from '@/application/types';
import { AddressCorrectionState, InvalidAddress } from '../types';

export const addressCorrectionMutations: MutationTree<AddressCorrectionState> = {

  clear(state) {
    state.invalidAddresses = [];

    state.getInvalidAddressesStatus = ActionStatus.None;
    state.correctAddressesStatus = ActionStatus.None;
  },

  // Set limit

  setLimit(state, limit: number): void {
    state.limit = limit;
  },

  // Get invalid addresses

  getInvalidAddressesStarted(state): void {
    state.getInvalidAddressesStatus = ActionStatus.InProgress;
  },

  getInvalidAddressesSucceeded(state, invalidAddresses: InvalidAddress[]): void {
    state.invalidAddresses = invalidAddresses;
    state.getInvalidAddressesStatus = ActionStatus.Successful;
  },

  getInvalidAddressesFailed(state): void {
    state.getInvalidAddressesStatus = ActionStatus.Failed;
  },

  // Get invalid address

  getInvalidAddressStarted(state): void {
    state.getInvalidAddressStatus = ActionStatus.InProgress;
  },

  getInvalidAddressSucceeded(state, invalidAddress: InvalidAddress): void {
    state.invalidAddresses = [invalidAddress];
    state.getInvalidAddressStatus = ActionStatus.Successful;
  },

  getInvalidAddressFailed(state): void {
    state.getInvalidAddressStatus = ActionStatus.Failed;
  },

  // Correct addresses

  correctAddressesStarted(state): void {
    state.correctAddressesStatus = ActionStatus.InProgress;
  },

  correctAddressesSucceeded(state): void {
    state.correctAddressesStatus = ActionStatus.Successful;
  },

  correctAddressesFailed(state): void {
    state.correctAddressesStatus = ActionStatus.Failed;
  },

};
